// extracted by mini-css-extract-plugin
module.exports = {"button":"_base-button_button_1_hTJ"};